module.exports = __webpack_public_path__ + "media/assets/images/smart_working/7-1-s-696d3b8e27be1fff7f961ce99e69566c.jpg";